import { useMarkAndMeasureOnMount } from '../hooks/useMarkAndMeasureOnMount';
const MarkAndMeasureOnMount = ({
  measurement
}) => {
  useMarkAndMeasureOnMount(measurement);
  return null;
};
export default MarkAndMeasureOnMount;